import React from "react";

import { FinancePanel } from "../../components/finance/index.js";

export default () => <FinancePanel />;
